import { STORE_ORDER_STATUS_OBJ, isStoreOrderAllowedStatusChange } from "@lib/types/storeOrderStatus";
import { ref } from "vue";
import { toast } from "@/ui-plus/sonner";
import AcceptOrderModal from "./AcceptOrderModal.vue";
import { printOrder } from "./printHTML";
import { checkNewOrders } from "./playAudio";
import { printAfterAccept } from "./copiesNumber";
import { cachedStoreOrders } from "./RecentOrdersStore";
import { storeOrdersApiClient } from "@api-client/store_orders";
import { useDialog } from "@/ui-plus/dialog/use-dialog";
const dialog = useDialog();

const browserLocale = window.navigator.language;

export let isAcceptingOrder = ref(false);

export const handleAcceptApi = async (storeOrderId: string, storeId: string, minutes: number | undefined) => {
    if (isAcceptingOrder.value) {
        return;
    }
    isAcceptingOrder.value = true;
    const { error } = await (await storeOrdersApiClient[":storeId"].accept_order.$post({
        param: { storeId },
        json: { storeOrderId, estimatedTimeInMinutes: minutes }
    })).json();
    setTimeout(() => {
        checkNewOrders();
    }, 1000);
    if (error) {
        toast.error(error.message ?? "Error accepting order");
    } else {
        toast.message(`Order accepted`);
        isStoreOrderAllowedStatusChange(cachedStoreOrders.value[storeOrderId].orderStatus, STORE_ORDER_STATUS_OBJ.ACCEPTED);
        cachedStoreOrders.value[storeOrderId].orderStatus = STORE_ORDER_STATUS_OBJ.ACCEPTED;
        if (minutes) {
            cachedStoreOrders.value[storeOrderId].estimatedTimeJSON = {
                min: minutes,
                unit: 'minutes'
            }
        }
        // Update the timestamp to prevent the periodic refresh from reloading this order
        cachedStoreOrders.value[storeOrderId].updated_at_ts = Date.now();
        checkNewOrders();
        if (printAfterAccept.value) {
            printOrder(cachedStoreOrders.value[storeOrderId], browserLocale);
        }
    }
    isAcceptingOrder.value = false;
}

export const handleAccept = async (storeOrderId: string, storeId: string) => {
    dialog.show<number | undefined>({
        title: "Accept Order",
        closeable: true,
        component: AcceptOrderModal,
        onSuccess: async (minutes) => {
            await handleAcceptApi(storeOrderId, storeId, minutes);
        },
        onError: async (error) => {
            console.log(error);
        }
    });

}